import { render, staticRenderFns } from "./Pressrelease.vue?vue&type=template&id=bfeeb154&scoped=true&"
import script from "./Pressrelease.vue?vue&type=script&lang=js&"
export * from "./Pressrelease.vue?vue&type=script&lang=js&"
import style0 from "./Pressrelease.vue?vue&type=style&index=0&id=bfeeb154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfeeb154",
  null
  
)

export default component.exports